"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringAltRenderFactory = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const Chip_1 = __importDefault(require("@opsbase/web-chips/Chip"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const get_1 = __importDefault(require("lodash/get"));
const react_1 = __importDefault(require("react"));
const useAltForSelfLang_1 = __importDefault(require("@opsbase/react-ctrl-self/helpers/useAltForSelfLang"));
const StringAltRenderFactory = (viewField) => (item) => {
    const title = (0, get_1.default)(item, 'title');
    const titleAlt = (0, get_1.default)(item, viewField.propertyName);
    const [localTitle] = (0, useAltForSelfLang_1.default)(title, titleAlt);
    if (!localTitle)
        return null;
    // SHOW AS CHIPS
    if (viewField.showAsChip) {
        if (Array.isArray(localTitle)) {
            return (react_1.default.createElement(Horizontal_1.default, { flexWrap: "wrap" }, localTitle.map(v => (react_1.default.createElement(Chip_1.default, { small: true, key: v, label: v, color: lib_palette_1.default.LavendarGrey })))));
        }
        else {
            return react_1.default.createElement(Chip_1.default, { small: true, label: localTitle.toString(), color: lib_palette_1.default.LavendarGrey });
        }
    }
    // SHOW AS STRING
    if (Array.isArray(localTitle)) {
        return react_1.default.createElement(Text_1.default, null, localTitle.join(', '));
    }
    else {
        return react_1.default.createElement(Text_1.default, null, localTitle.toString());
    }
};
exports.StringAltRenderFactory = StringAltRenderFactory;
exports.default = exports.StringAltRenderFactory;
